/* global axios */

// app/javascript/dashboard/api/bots.js
//
// B.3 hotfix (2026-04-18): herda ApiClient igual todos os outros clients do
// Chatwoot. O axios cru anterior NÃO passava pelo interceptor de auth, o que
// causava 401 em GET /bmt_bots, POST /bmt_bots e nos endpoints da Fase 5B
// (trigger, bot_flow_triggers, bmt_bot_sessions).
//
// accountId NÃO é mais passado nos métodos — ApiClient extrai automático da
// URL (/app/accounts/:id/...) via `accountIdFromRoute`.

import ApiClient from './ApiClient';

class BotsAPI extends ApiClient {
  constructor() {
    // resource: 'bmt_bots' -> url fica /api/v1/accounts/:accountId/bmt_bots
    super('bmt_bots', { accountScoped: true });
  }

  // Aliases semânticos pra compat com callsites pré-hotfix.
  // Os métodos do ApiClient (get/show/create/update/delete) são os "canônicos".
  getBots() {
    return this.get();
  }
  getBot(id) {
    return this.show(id);
  }
  createBot(data) {
    return this.create(data);
  }
  updateBot(id, data) {
    return this.update(id, data);
  }
  deleteBot(id) {
    return this.delete(id);
  }

  // Sprint #47.29: clonar bot
  duplicateBot(id) {
    return axios.post(`${this.url}/${id}/duplicate`);
  }

  // Fase 5B — disparo manual + sessões
  triggerBot(botId, conversationDisplayId) {
    return axios.post(`${this.url}/${botId}/trigger`, {
      conversation_id: conversationDisplayId,
    });
  }

  getBotFlowTriggers(conversationDisplayId) {
    // Rota aninhada sob conversations — não sob bmt_bots. Usa baseUrl() direto.
    return axios.get(
      `${this.baseUrl()}/conversations/${conversationDisplayId}/bot_flow_triggers`,
    );
  }

  cancelBotSession(sessionId) {
    return axios.delete(`${this.baseUrl()}/bmt_bot_sessions/${sessionId}`);
  }

  // Sprint 5.0.4: Bot Simulator (dry-run). Stateless — frontend mantem
  // session_state e envia a cada turno. options { skip_wait, mock_integration }.
  // flow inline opcional (editor sem salvar) — backend usa @bot.flow do DB
  // se ausente.
  simulate(botId, { user_message, session_state, options, flow }) {
    return axios.post(`${this.url}/${botId}/simulate`, {
      user_message,
      session_state,
      options,
      flow,
    });
  }
}

export default new BotsAPI();
